export default __webpack_public_path__ + "locales/ar-SA/Webhooks.json?hash=72b0070b75a968859b8f2dd782a28252";